import React from "react"
import { Box } from "@mui/material"
import GenericHeaderReturnButton from "./GenericHeaderReturnButton"

const classes = {
    root: {
        display: "flex",
        padding: "0 20px",
        boxShadow: "0 4px 11px 0 rgba(0, 0, 0, 0.10)",
        backgroundColor: "#fff",
        height: 64,
    }
}

const GenericTopBarHeader = (props) => {
    const {
        leftAction,
        title,
        info,
        rightAction,
        className,
        sx,
        onBack
    } = props

    return (
        <Box
            className={className}
            sx={{ ...classes.root, ...sx }}
        >
            {onBack && (
                <Box sx={{ mr: 1 }} className="flexRow center">
                    <GenericHeaderReturnButton handleClick={onBack} />
                </Box>
            )}
            {leftAction && (
                <Box sx={{ mr: 1 }} className="flexRow center">
                    {leftAction}
                </Box>
            )}
            {title && (
                <div className="flexRow center">
                    {title}
                </div>
            )}
            {info && (
                <div className="flexRow center">
                    {info}
                </div>
            )}
            {rightAction && (
                <div className="flexRow center justifyEnd flex1">
                    {rightAction}
                </div>
            )}
        </Box>
    )
}

export default GenericTopBarHeader
